// extracted by mini-css-extract-plugin
module.exports = {"help":"Help-m__help___cig7e","danger":"Help-m__danger___XYIHD"};